import React from 'react';

export type IconeChippuAvaliacaoProps = {
  cor: string;
  altura: number;
  largura: number;
  offset: number;
};

const IconeChippuAvaliacao = ({
  cor,
  altura,
  largura,
  offset,
}: IconeChippuAvaliacaoProps) => {
  const gradId = `grad-${Math.random()}`;

  return (
    <svg
      width={largura}
      height={altura}
      viewBox="0 0 29 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="0">
          <stop offset={offset} stopColor={cor} stopOpacity="1" />
          <stop offset={offset} stopColor={cor} stopOpacity="0.5" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradId})`}
        d="M21.2169 13.8433L14.6186 20.4383C14.252 20.8047 13.759 21.0069 13.2407 21.0069C12.7224 21.0069 12.2294 20.8047 11.8629 20.4383L7.94429 16.5217C7.76732 16.3449 7.6156 16.1301 7.51448 15.89C7.41335 15.65 7.3628 15.3973 7.3628 15.1447C7.3628 14.892 7.41335 14.6392 7.51448 14.3991C7.6156 14.1591 7.75468 13.9443 7.94429 13.7674C8.12126 13.5905 8.33615 13.439 8.57632 13.3379C8.81649 13.2368 9.06934 13.1863 9.32215 13.1863C9.57497 13.1863 9.82774 13.2368 10.0679 13.3379C10.3081 13.439 10.523 13.5779 10.6999 13.7674L13.2407 16.3069L18.4613 11.089C18.8279 10.7226 19.3208 10.5205 19.8391 10.5205C20.3573 10.5205 20.8504 10.7226 21.2169 11.089C21.5835 11.4554 21.7858 11.9482 21.7858 12.4662C21.7858 12.9842 21.5835 13.4769 21.2169 13.8433ZM24.0105 4.80982C22.1018 2.90206 19.6748 1.60079 17.0202 1.07015C14.3784 0.539515 11.6227 0.792155 9.11986 1.81552C6.61702 2.83889 4.48076 4.56987 2.96389 6.80612C1.44701 9.04237 0.625379 11.6703 0.600098 14.374V36.3953C0.600098 37.1407 0.890863 37.8483 1.42177 38.3789C1.95267 38.9096 2.66048 39.2001 3.40628 39.2001C4.15207 39.2001 4.85996 38.9096 5.39086 38.3789C5.92177 37.8483 6.21253 37.1407 6.21253 36.3953V25.5679C9.00611 27.602 12.457 28.5117 15.8952 28.12C19.3208 27.7157 22.481 26.0479 24.7311 23.42C26.9811 20.8047 28.1566 17.4314 28.0176 13.9823C27.8912 10.5331 26.4628 7.26085 24.0231 4.80982Z"
      />
    </svg>
  );
};

export default IconeChippuAvaliacao;
